/* eslint-disable-rule no-mixed-operators */
import React, { useState } from 'react'
import { get, put } from '../modules/fetch'
import Loading from './Loading'
// import ImageEdit from './ImageEdit'
import Image from './Image'
import { If } from '../modules/helpers'

let component_mounted = false
const model = 'article'

const ArticleRedirectImages = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [status, setStatus] = useState((id && 'fetching') || 'ready')
    const [object, setObject] = useState({})
    const [html, setHTML] = useState({})
    const [image_redirects, setImageRedirects] = useState([])

    if (!component_mounted && id) {
        component_mounted = true
        setStatus('fetching')
        get(model + '/' + id + '?scope=images')
            // .then(r => r.json())
            .then((r) => console.log(r) || r)
            .then((r) => {
                setObject(r)
                const html = ((r.body.substring(0, 1) === '{' || r.body.substring(0, 1) == '[') && JSON.parse(r.body)) || r.body
                const image_redirects =
                    (r.image_redirects &&
                        (r.image_redirects.substring(0, 1) === '{' || r.image_redirects.substring(0, 1) == '[') &&
                        JSON.parse(r.image_redirects)) ||
                    r.image_redirects
                setHTML(html)
                image_redirects && setImageRedirects(image_redirects)
                setStatus('ready')
            })
    }
    const save = () => {
        setStatus('saving')
        put('article/' + id, { image_redirects: JSON.stringify(image_redirects) })
            .then((r) => console.log(r) || r)
            .then(() => setStatus('saved'))
    }
    const onDragStart = (e) => {
        console.log(e)
        e.dataTransfer.setData('text/plain', e.target.src)
    }
    const onDrop = (e, src) => {
        e.preventDefault()
        console.log(e.dataTransfer.getData('text'))
        setImageRedirects([
            ...image_redirects.filter((i) => i.wordpress_src !== src),
            { wordpress_src: src, perfectsense_src: e.dataTransfer.getData('text').replace('https://admin.perfectsen.se/images/', '') },
        ])
    }
    const displayImage = (src, index) => {
        const src_obj = image_redirects.find((i) => i.wordpress_src === src) || {}
        const input = (
            <React.Fragment>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">Wordpress url</span>
                    </div>
                    <input type="text" className="form-control" value={src} onChange={() => {}} disabled />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">Perfectsense url</span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                            setImageRedirects([
                                ...image_redirects.filter((i) => i.wordpress_src !== src),
                                { wordpress_src: src, perfectsense_src: e.target.value },
                            ])
                        }
                        onDrop={(e) => onDrop(e, src)}
                        value={src_obj.perfectsense_src}
                    />
                </div>
            </React.Fragment>
        )
        return (
            (src && (
                <div
                    className={'mb-3 p-3 ' + ((src_obj.perfectsense_src && 'bg-success') || 'bg-danger')}
                    key={`source-image-${index}`}
                    style={{ position: 'relative' }}
                >
                    {(src_obj.perfectsense_src && (
                        <div style={{ position: 'absolute', right: '-140px', top: '80px', maxWidth: '140px' }}>
                            <i className="fal fa-arrow-right"></i>
                            <Image style={{ maxWidth: '100px', marginLeft: '10px' }} src={src_obj.perfectsense_src} />
                        </div>
                    )) ||
                        null}
                    <Image src={src} className="mb-3" onDrop={(e) => onDrop(e, src)} />
                    {input}
                </div>
            )) ||
            null
        )
    }
    // console.log({image_redirects})
    return (
        <React.Fragment>
            {(status === 'fetching' && <Loading />) || null}
            {status !== 'fetching' && (
                <React.Fragment>
                    <div className="row">
                        <div className="col-10">
                            <h1 className="mb-3">{object.title}</h1>
                        </div>
                        <div className="col-2 text-right">
                            <div className="btn btn-primary" onClick={save} disabled={status === 'saving'}>
                                <If true={status === 'ready'}>
                                    <span>Save</span>
                                </If>
                                <If true={status === 'saving'}>
                                    <span>
                                        Saving <i className="fal fa-circle-notch fa-spin" />
                                    </span>
                                </If>
                                <If true={status === 'saved'}>
                                    <span>
                                        Saved <i className="fal fa-check" />
                                    </span>
                                </If>
                            </div>
                        </div>
                    </div>
                    <p>
                        Every item in the left column (Wordpress) should be green. If not, drag an image from the current article (right column) and drop it on
                        the desired item on the left. Both columns are scrollable.
                        <br />
                        Don't forget to save.
                    </p>
                    <div className="row">
                        <div className="col-7" style={{ height: '96vh', overflow: 'scroll', position: 'sticky', top: '56px' }}>
                            <div className="row">
                                <div className="col-9">
                                    <strong>Wordpress</strong>
                                    <div>{object.source_img_array && object.source_img_array.map(displayImage)}</div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-2">
                        </div> */}
                        <div className="col-5">
                            <strong>Perfectsense</strong>
                            {html &&
                                html
                                    .filter((b) => b.type === 'amazon' || b.type === 'image')
                                    .map(
                                        (block, index) =>
                                            (block.content &&
                                                block.content.id &&
                                                ((block.type === 'image' && (
                                                    <Image
                                                        key={`image-${index}`}
                                                        {...block.content}
                                                        onDragStart={onDragStart}
                                                        style={{
                                                            opacity:
                                                                (image_redirects.find((i) => i.perfectsense_src === block.content.path + block.content.src) &&
                                                                    0.5) ||
                                                                1,
                                                        }}
                                                    />
                                                )) || (
                                                    <Image
                                                        key={`image-${index}`}
                                                        {...block.content.image}
                                                        onDragStart={onDragStart}
                                                        style={{
                                                            opacity:
                                                                (image_redirects.find(
                                                                    (i) => i.perfectsense_src === block.content.image.path + block.content.image.src
                                                                ) &&
                                                                    0.5) ||
                                                                1,
                                                        }}
                                                    />
                                                ))) ||
                                            null
                                    )}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ArticleRedirectImages
